import { BackInStockConfiguration } from '../../helpers/BackInStockConfiguration';
import { Modal } from '@ori/online-modal';
import { NotifyCumulus } from '../NotifyCumulus/NotifyCumulus';
import { NotifyNonCumulus } from '../NotifyNonCumulus/NotifyNonCumulus';
import { Name, } from '@ori-events/open-back-in-stock-notification-dialog';
import React, { useCallback, useEffect, useState } from 'react';
export const NotifyPopup = () => {
    const { isCumulusMarket } = BackInStockConfiguration.getConfig();
    const [productCode, setProductCode] = useState('');
    const [isDialogOpen, setDialogOpen] = useState(false);
    const closeDialog = useCallback(() => {
        setDialogOpen(false);
    }, []);
    const element = isCumulusMarket ? (React.createElement(NotifyCumulus, { productCode: productCode })) : (React.createElement(NotifyNonCumulus, { productCode: productCode }));
    useEffect(() => {
        const openDialog = (event) => {
            const { code } = event.detail;
            setDialogOpen(true);
            setProductCode(code);
        };
        window.addEventListener(Name, openDialog);
        return () => window.removeEventListener(Name, openDialog);
    }, []);
    return (React.createElement(Modal, { title: '', isOpen: isDialogOpen, onClose: closeDialog }, element));
};
